import { useState } from 'react';
import { Section } from '../components/Section';

const TRENDING: ReadonlyArray<[string, number]> = [
  ['Are linters obsolete?', 412],
  ['Should agents commit directly to main?', 287],
  ['Is "context window" the new "RAM"?', 201],
  ['TDD vs EDD vs vibes', 168],
  ['Can a bot be on-call?', 134],
];

export function SubmitTopic(): JSX.Element {
  const [topic, setTopic] = useState('');
  const [reason, setReason] = useState('');
  const [sent, setSent] = useState(false);
  const [count, setCount] = useState(243);

  return (
    <Section
      label="HAVE A BONE TO PICK?"
      title={<>Submit a debate motion.</>}
      kicker="What argument do you actually want resolved? Most-voted motions become future episodes."
      background="paper"
    >
      <div className="grid gap-8" style={{ gridTemplateColumns: '1.3fr 1fr' }}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (topic) {
              setSent(true);
              setCount((c) => c + 1);
            }
          }}
          className="rounded-[14px] border-2 border-ink bg-bg p-7"
          style={{ boxShadow: '5px 5px 0 rgb(var(--color-ink))' }}
        >
          <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.1em] text-ink-soft">The motion</label>
          <input
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="Should AI write your tests?"
            className="w-full rounded-[10px] border-2 border-ink bg-paper px-3.5 py-3 font-display text-lg font-semibold text-ink outline-none"
          />
          <label className="mb-1.5 mt-4 block font-mono text-[11px] uppercase tracking-[0.1em] text-ink-soft">
            Why this matters
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="What's the real argument? Who's wrong about this?"
            rows={4}
            className="w-full resize-y rounded-[10px] border-2 border-ink bg-paper px-3.5 py-3 text-sm text-ink outline-none"
          />
          <div className="mt-4 flex items-center justify-between">
            <span className="font-mono text-xs text-ink-soft">{count} motions submitted this season</span>
            <button
              type="submit"
              disabled={!topic || sent}
              className="rounded-full px-[22px] py-3 font-display text-[15px] font-bold text-bg disabled:cursor-default"
              style={{
                background: sent ? 'rgb(var(--color-beak))' : 'rgb(var(--color-ink))',
                opacity: !topic ? 0.5 : 1,
              }}
            >
              {sent ? '✓ Submitted! Quack received.' : 'Submit motion →'}
            </button>
          </div>
        </form>
        <div className="flex flex-col gap-2.5">
          <div className="mb-1 font-mono text-[11px] uppercase tracking-[0.1em] text-ink-soft">Currently trending</div>
          {TRENDING.map(([t, n]) => (
            <div
              key={t}
              className="flex items-center justify-between rounded-[10px] border-[1.5px] border-[rgb(var(--color-ink)/12%)] bg-bg px-3.5 py-3"
            >
              <span className="font-display text-sm font-semibold text-ink">{t}</span>
              <span className="font-mono text-xs font-bold text-beak">▲ {n}</span>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
